// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "passenger--ARPc";
var _4 = "passenger__passTitle-1KXXu";
var _5 = "passenger__passTitle_title-3VvG2";
var _6 = "relink-3SIha";
var _7 = "change__button-2h4_E";
var _8 = "ticket__button_root-2Lw43";
var _9 = "ticket__button_endIcon-3eToA";
export { _1 as "__esModule", _2 as "mobile", _3 as "passenger", _4 as "passenger__passTitle", _5 as "passenger__passTitle_title", _6 as "relink", _7 as "change__button", _8 as "ticket__button_root", _9 as "ticket__button_endIcon" }
export default { "__esModule": _1, "mobile": _2, "passenger": _3, "passenger__passTitle": _4, "passenger__passTitle_title": _5, "relink": _6, "change__button": _7, "ticket__button_root": _8, "ticket__button_endIcon": _9 }
